const APP_STORE_URL = "https://apps.apple.com/app/id6777460189";
const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.waidbook.app";

export function AppStoreBadge({ testid = "appstore-badge", className = "" }) {
  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      aria-label="Download Waidbook on the App Store"
      className={`inline-block transition-transform duration-200 hover:scale-[1.03] ${className}`}
    >
      <img
        src="/appstore-badge.svg"
        alt="Download on the App Store"
        className="h-12 w-auto sm:h-[52px]"
        draggable="false"
      />
    </a>
  );
}

/* Active "Download nu op Google Play" badge, styled to match the App Store
   badge dimensions so both stores sit side by side consistently. */
export function GooglePlayBadge({ testid = "googleplay-badge", className = "" }) {
  return (
    <a
      href={GOOGLE_PLAY_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      aria-label="Download nu op Google Play"
      className={`inline-flex h-12 items-center gap-2.5 rounded-[10px] border border-white/20 bg-black px-4 transition-transform duration-200 hover:scale-[1.03] sm:h-[52px] ${className}`}
    >
      <svg viewBox="0 0 24 24" className="h-6 w-6 flex-shrink-0" aria-hidden="true">
        <path d="M3.6 2.2 13 11.6 3.6 21a1.6 1.6 0 0 1-.5-1.2V3.4c0-.46.19-.88.5-1.2Z" fill="#00D3FF" />
        <path d="M16.7 8.6 13 11.6l3.7 3-3.7 3.4 9.9-5.7c.9-.52.9-1.8 0-2.3l-2.6-1.5-3.6 2.1Z" fill="#FFCE00" />
        <path d="M6.8 1.5 16.7 8.6 13 11.6 3.6 2.2c.31-.32.73-.5 1.19-.5.34 0 .68.1.99.29L6.8 1.5Z" fill="#00F076" />
        <path d="M13 11.6l3.7 3-9.9 5.7-.51.3c-.31.19-.65.29-.99.29-.46 0-.88-.18-1.2-.49L13 11.6Z" fill="#FF3A44" />
      </svg>
      <div className="text-left leading-tight">
        <div className="text-[9px] uppercase tracking-widest text-white/60">Download nu op</div>
        <div className="text-base font-semibold text-white">Google Play</div>
      </div>
    </a>
  );
}

export default function StoreBadges({ className = "", showGooglePlay = true }) {
  return (
    <div className={`flex flex-wrap items-center gap-4 ${className}`}>
      <AppStoreBadge />
      {showGooglePlay && <GooglePlayBadge />}
    </div>
  );
}
